<button
  class="med-btn"
  [type]="type"
  [disabled]="disabled"
  [ngClass]="classList"
>
  <ng-content></ng-content>
</button>
